// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Report_attributes_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/report_attributes/salvar
 *
 * Creates or updates a report attribute.
 * - Create: requires name and type only (id is null)
 * - Update: requires id, name, and type
 */
import { registerContract } from './validate'

export interface Report_attributes_SalvarInput {
so_ra_name: string
so_ra_type: string
so_ra_id?: number
so_ra_active?: number
}

registerContract('Report_attributes_SalvarInput', {
  so_ra_name:   { type: 'string',  required: true },
  so_ra_type:   { type: 'string',  required: true },
  so_ra_id:     { type: 'number',  required: false },
  so_ra_active: { type: 'number',  required: false },
})
